import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

function Dialog(props) {
  const {
    className,
    title,
    content,
    show,
    overlayClickable,
    confirmText,
    cancelText,
    isShowCancel,
    isShowConfirm,
    onCancel,
    onConfirm
  } = props;

  return (
    show && (
    <div className={className}>
      <div className={'dialog-container'}>
        {/* 遮罩层 */}
        {overlayClickable ? (
          <div className={'mask'} onClick={onCancel} />
        ) : (
          <div className={'mask'} />
        )}

        {/* 弹框 */}
        <div className={'innerContainer'}>
          <div className={'content'}>
            {/* 标题 */}
            {!!title && (
            <div className={'title'}>
              <div>{title}</div>
              <div className="wrap_close" onClick={onCancel}>
                <img className="close_icon" src={'https://img14.360buyimg.com/imagetools/jfs/t1/218194/11/27942/546/6487d0daF709f27e1/87eb2889d67e4287.png'} />
              </div>
            </div>
            )}
            {typeof content === 'string' ? <div className={'main'}>{content}</div> : content}
          </div>

          <div className={'btn_group'}>
            {isShowCancel && (
            <div className={'btn cancel_btn'} onClick={onCancel}>
              <span className={'cancel_text'}>{cancelText}</span>
            </div>
            )}
            {isShowConfirm && <div className={'btn sure_btn'} onClick={onConfirm}>
              <span className={'sure_text'}>{confirmText}</span>
            </div>}
          </div>
        </div>
      </div>
    </div>
    )
  );
}

Dialog.propTypes = {
  title: PropTypes.string, // 标题
  show: PropTypes.bool.isRequired, // 是否展示
  onConfirm: PropTypes.func, // 点击确定的回调方法
  onCancel: PropTypes.func, // 点击取消按钮的回调
  isShowCancel: PropTypes.bool, // 是否显示取消按钮
  isShowConfirm: PropTypes.bool, // 是否显示确定按钮
  cancelText: PropTypes.string, // 取消按钮文案
  confirmText: PropTypes.string, // 确定按钮文案
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]), // 弹框内容
  overlayClickable: PropTypes.bool, // 点击膜层后是否关闭对话框，默认是关闭的
};

Dialog.defaultProps = {
  cancelText: '取消',
  confirmText: '确定',
  isShowCancel: false,
  isShowConfirm: false,
};

export default styled(Dialog)`
  .dialog-container {
    display: flex;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 102;
  }
  .innerContainer {
    position: absolute;
    z-index: 104;
    width: 6rem;
    max-height: 6rem;
    background-color: #fff;
    border-radius: 0.24rem;
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.25rem;
    height: 100%;
  }
  .btn_group {
    display: flex;
    justify-content: center;
    margin-bottom: 0.18rem;
  }
  .title {
    font-size: 0.26rem;
    padding-bottom: 0.2rem;
    font-weight: 500;
    color: #424854;
  }
  .wrap_close {
    position: absolute;
    right: 0.06rem;
    top: 0;
    line-height: 1;
    padding: 0.1rem;
  }
  .close_icon {
    width: 0.13rem;
    height: 0.13rem;
  }
  .main {
    font-size: 0.14rem;
    line-height: 0.2rem;
    color: #848689;
    max-height: 2.66rem;
    overflow-y: scroll;
  }
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 1.12rem;
    height: 0.35rem
    margin: 0 0.1rem;
    font-size: 0.15rem;
  }
  .cancel_btn {
    border: 1px solid #f2270c;
    border-radius: 0.17rem;
  }
  .sure_btn {
    width: 2.3rem;
    background: linear-gradient(
      135deg,
      rgba(242, 20, 12, 1) 0%,
      rgba(242, 39, 12, 1) 69.83950099728881%,
      rgba(242, 77, 12, 1) 100%
    );
    border-radius: 0.68rem;
  }
  .cancel_text {
    color: #f2270c;
  }
  .sure_text {
    color: #fff;
  }
  .business-qualification-material-modal {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    overflow-y: scroll;
  }
  .business-qualification-material-item {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.14rem;
    font-size: 0.22rem;
  }
  .business-qualification-material-img {
    width: 100%;
    height: 100%;
    margin-bottom: 0.2rem;
    object-position: center;
    object-fit: contain;
  }
`;
